import { render, staticRenderFns } from "./user-add-dialog.vue?vue&type=template&id=f02c39b0&"
import script from "./user-add-dialog.vue?vue&type=script&lang=js&"
export * from "./user-add-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports